export const Routes = {
  HOME_PATH: '/',
  DASHBOARD_PATH: '/dashboard',
  LOGIN_PATH: '/login',
  TIMESHEET_PATH: '/timesheets',
  HISTORY_ACTIONS_PATH: '/history-actions',
  ADVANCE_REQUEST_LIST_PATH: '/advance-request',
  ADVANCE_REQUEST_HISTORY_PATH: '/advance-request/history',
  ADVANCE_REQUEST_MANAGE_PATH: '/advance-request/manage',
  DELEGATIONS_PATH: '/delegations',
  DELEGATIONS_SHOW_PATH: '/delegation',
  DELEGATIONS_CREATE_PATH: '/create-delegation',
  NOTION_PATH: '/notion',
  IMPORT_INDEX_PATH: '/imports',
  IMPORT_PATH: '/import',
  IMPORT_MAPPER: '/import-mapper',
  IMPORT_MAPPING_PATH: '/imports/mapping/:agencyId/:clientId',
  IMPORT_CREATE_PATH: '/imports/create',
  SUPER_ADMIN: '/super-admin',
  REFERENTIALS_PATH: '/referentials',
  MONITORING_PATH: '/monitoring',
  ADMIN_USERS_PATH: '/admin/users',
  MISSING_AGENCIES_PATH: '/missing-agencies',
};
